import {
  PlaceCurrentCartsFailedAction,
  PlaceCurrentCartsSucceededAction,
  placeCurrentCartsFailedType,
  placeCurrentCartsSucceededType
} from '../../carts/cartsSlice';
import { call, put, race, select, take } from 'typed-redux-saga';
import trackFiltersActions, { FiltersEventType } from '@spa/lib/tracking/trackFiltersActions';
import { AddedSearchFilters } from '../../search/SearchState';
import { CartTypeQuantityData } from '@spa/lib/tracking/pushToDataLayer';
import { StateCart } from '../../carts/CartsState';
import selectAddedProductFilters from '../../search/selectors/selectAddedProductFilters';
import selectAuthenticatedUserId from '../../auth/selectors/selectAuthenticatedUserId';
import selectLastQueryMetadata from '../../search/selectors/selectLastQueryMetadata';
import selectSessionUserId from '../../session/selectors/selectSessionUserId';
import { setEmptySearchFilters } from '../../search/searchSlice';

export function* trackPurchase(
  _cartQuantityData: CartTypeQuantityData,
  cart: StateCart
): Generator {
  const anonymousUserId: string | null = yield* select(selectSessionUserId);
  const authenticatedUserId: string | null = yield* select(selectAuthenticatedUserId);
  const lastQueryMetadata: Record<string, string> = yield* select(selectLastQueryMetadata);
  const addedProductFilters: Array<AddedSearchFilters> = yield* select(selectAddedProductFilters);
  const currentProductsFilters: Array<string> = addedProductFilters.flatMap(
    (productFilter): Array<string> =>
      cart?.entries.some((entry): boolean => entry.product.code === productFilter.productCode)
        ? productFilter.filters
        : []
  );
  const uniqueCurrentProductsFilters: Array<string> = Array.from(new Set(currentProductsFilters));

  const { placeCurrentCartsSucceeded, placeCurrentCartsFailure } = yield* race({
    placeCurrentCartsSucceeded: take<PlaceCurrentCartsSucceededAction>(
      placeCurrentCartsSucceededType
    ),
    placeCurrentCartsFailure: take<PlaceCurrentCartsFailedAction>(placeCurrentCartsFailedType)
  });

  if (placeCurrentCartsSucceeded !== undefined && placeCurrentCartsFailure === undefined) {
    if (uniqueCurrentProductsFilters.length > 0) {
      yield* call(
        trackFiltersActions,
        FiltersEventType.CONVERTED_SELECTED_PURCHASE,
        uniqueCurrentProductsFilters,
        anonymousUserId,
        authenticatedUserId,
        lastQueryMetadata
      );
      yield* put(setEmptySearchFilters());
    }
  }
}
